import { ReactElement } from 'react'
import { Bar, RectangleProps } from 'recharts'

import { SalesReportGraphData } from '../../../types/salesReportGraphData'
import { SalesReportGraphBar } from '../elements/SalesReportGraphBar'
import { GraphBarType } from '../enums/graphBarType'
import { BarLayout } from '../types/barLayout'

const BAR_MIN_HEIGHT = 2

type BarRectangle = RectangleProps & SalesReportGraphData

export const generateBar = (dataKey: GraphBarType, barLayout: BarLayout): ReactElement => {
  return (
    <Bar
      activeBar={(props: BarRectangle) => (
        <SalesReportGraphBar {...props} barLayout={barLayout} dataKey={dataKey} isHovered />
      )}
      dataKey={dataKey}
      minPointSize={BAR_MIN_HEIGHT}
      shape={(props: BarRectangle) => <SalesReportGraphBar {...props} barLayout={barLayout} dataKey={dataKey} />}
      stackId="stack"
    />
  )
}
